import { Box, Divider, Typography } from "@drone-js/core";
import { AgodaLogo } from "apps/commons/components/AgodaLogo";
import type { FunctionComponent } from "react";
import { EmailUnsubscribeText } from "./constants/emailUnsubscribeText";

export const EmailUnsubscribePage: FunctionComponent = () => {
    return (
        <Box>
            <AgodaLogo />
            <Typography variant="heading-xl" mb="16" textColor="base.default">
                {EmailUnsubscribeText.YouAreNowUnsubscribed}
            </Typography>
            <Typography variant="body-default" mb="32" textColor="base.default">
                {EmailUnsubscribeText.WeAreSorryToSeeYouGo}
            </Typography>
            <Divider direction="horizontal" mb="16" />
            <Typography variant="caption-default" textColor="base.subtle">
                {EmailUnsubscribeText.CopyrightFooter}
            </Typography>
        </Box>
    );
};
